import {Separator} from 'platform/components';
import {Box} from 'platform/foundation';

import {ReactNode} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

interface WidgetContentProps extends TestIdProps {
  children: ReactNode;
}

export function WidgetContent(props: WidgetContentProps) {
  return (
    <Box data-testid={suffixTestId('widgetContent', props)}>
      <Separator spacing={0} />
      <Box paddingTop={4}>{props.children}</Box>
    </Box>
  );
}
